interface CoverageMeterScope extends ng.IScope {
  allocationDetails: any;
  totalCoverage: any;

  displayCoverageBar(): boolean;
  coverageStyle(): any;
  showAllocation(): boolean;
  allocationStyle(): any;
}

/**
 * This is how this code should have been done from the start
 * Compare and contrast with the original coverageMeter.directive.ts to see the difference
 * This version does not work off of $watches, does not use jQuery, etc.
 */
export default function CoverageMeterDirective() {
  'ngInject';

  return {
    scope: {
      totalCoverage: '=',
      allocationDetails: '='
    },
    restrict: 'A',
    replace: true,
    template: `
      <div class="unspscCoverageBar" ng-class="{ 'unspscNoCoverage' : !displayCoverageBar() }">
        <div ng-if="displayCoverageBar()">
          <div class="unspscCoverageBarCoverage" ng-style="coverageStyle()"></div>
          <div ng-show="showAllocation()" class="unspscCoverageBarAllocation"
            ng-style="allocationStyle()"></div>
          <div class="unspscCoverageBarFrame"></div>
        </div>
      </div>`,
    link: function ($scope: CoverageMeterScope, $element) {
      $scope.displayCoverageBar = function () {
        let data = meterData();

        return data.coverage > 0 || data.allocation > 0;
      };

      $scope.coverageStyle = function () {
        let data = meterData();

        var heightOffset = (data.coverage > 1 ? 1 : data.coverage) - 1;
        return {
          'background-position':
            Math.round(heightOffset * $element.width()) + 'px 0'
        };
      };

      $scope.showAllocation = function () {
        return $scope.allocationDetails.current;
      };

      $scope.allocationStyle = function () {
        let data = meterData();
        let allocationPx = 0;

        if (data.allocation) {
          let parentWidth = $element.width();

          allocationPx = Math.round(
            ((data.allocation > 1 ? 1 : data.allocation) - 1) * parentWidth
          );
          allocationPx = Math.max(-1 * (parentWidth - 4), allocationPx);

          return {
            'background-position': allocationPx + 'px 0'
          };
        }
      };

      function meterData() {
        let allocationDetails = $scope.allocationDetails || {};
        let coverage =
          $scope.totalCoverage != null
            ? $scope.totalCoverage
            : allocationDetails.spendCoveragePct;

        return {
          coverage: (coverage || 0) / 100,
          allocation: (allocationDetails.current || 0) / 100
        };
      }
    }
  };
}
